export default __webpack_public_path__ + "static/media/bsCoreBackground.15d7444c.svg";